import React from 'react';
import Icon from '../../../components/AppIcon';
import Input from '../../../components/ui/Input';

const ContactDetailsStep = ({ formData, onChange }) => {
  return (
    <div className="space-y-6">
      <div className="flex items-center gap-3 mb-6">
        <Icon name="Mail" size={24} className="text-blue-600" />
        <div>
          <h2 className="text-xl font-bold text-gray-900">Coordonnées</h2>
          <p className="text-sm text-gray-600">Informations de contact du cabinet</p>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Email du Cabinet <span className="text-red-500">*</span>
          </label>
          <Input
            type="email"
            value={formData?.email}
            onChange={(e) => onChange?.('email', e?.target?.value)}
            placeholder="contact@cabinet.fr"
            required
          />
        </div>
        
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Téléphone <span className="text-red-500">*</span>
          </label>
          <Input
            type="tel"
            value={formData?.phone}
            onChange={(e) => onChange?.('phone', e?.target?.value)}
            placeholder="+33 1 23 45 67 89"
            required
          />
        </div>
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">
          Email de Réception des Référals
        </label>
        <Input
          type="email"
          value={formData?.referralEmail}
          onChange={(e) => onChange?.('referralEmail', e?.target?.value)}
          placeholder="referrals@cabinet.fr (optionnel)"
        />
        <p className="mt-1 text-xs text-gray-500">
          Si différent de l'email principal. Laissez vide pour utiliser l'email du cabinet.
        </p>
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">
          Adresse
        </label>
        <Input
          value={formData?.address}
          onChange={(e) => onChange?.('address', e?.target?.value)}
          placeholder="15 rue de la République"
        />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Ville
          </label>
          <Input
            value={formData?.city}
            onChange={(e) => onChange?.('city', e?.target?.value)}
            placeholder="Paris"
          />
        </div>
        
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Code Postal
          </label>
          <Input
            value={formData?.postalCode}
            onChange={(e) => onChange?.('postalCode', e?.target?.value)}
            placeholder="75001"
          />
        </div>
      </div>
    </div>
  );
};

export default ContactDetailsStep;